import React from 'react';
import styled from 'styled-components';
import { motion } from 'framer-motion';
import { Download } from 'lucide-react';
import { Button } from './ui';
import { colors } from '../styles/colors';
import { typography } from '../styles/typography';
import { spacing } from '../styles/spacing';

const PromptContainer = styled(motion.div)`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 100vh;
  text-align: center;
  background: ${colors.background.primary};
  padding: ${spacing[4]};
`;

const Title = styled.h1`
  font-family: ${typography.fonts.primary};
  font-size: ${typography.sizes['3xl']};
  font-weight: ${typography.weights.bold};
  color: ${colors.text.primary};
  margin-bottom: ${spacing[2]};
`;

const Subtitle = styled.p`
  font-family: ${typography.fonts.primary};
  font-size: ${typography.sizes.lg};
  color: ${colors.text.secondary};
  max-width: 400px;
  margin-bottom: ${spacing[6]};
`;

interface InstallPwaPromptProps {
  onInstallClick: () => void;
}

const InstallPwaPrompt: React.FC<InstallPwaPromptProps> = ({ onInstallClick }) => {
  return (
    <PromptContainer
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      transition={{ duration: 0.5 }}
    >
      <Title>Welcome to Chikishoun Memory Garden!</Title>
      <Subtitle>
        For the best experience, add this app to your home screen.
      </Subtitle>
      <Button onClick={onInstallClick} size="lg">
        <Download size={20} />
        <span>Add to Home Screen</span>
      </Button>
    </PromptContainer>
  );
};

export default InstallPwaPrompt;
